"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDecorator = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var BaseDecorator = /** @class */ (function (_super) {
    tslib_1.__extends(BaseDecorator, _super);
    function BaseDecorator(props) {
        var _this = _super.call(this, props) || this;
        _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
        return _this;
    }
    /**
     * Updates the ref to the component composed by the decorator, which will also take care of hoisting
     * (and unhoisting as appropriate) methods from said component.
     *
     * Pass this method as the argument to the 'ref' property of the composed component.
     */
    BaseDecorator.prototype._updateComposedComponentRef = function (composedComponentInstance) {
        this._composedComponentInstance = composedComponentInstance;
        if (composedComponentInstance) {
            this._hoisted = (0, Utilities_1.hoistMethods)(this, composedComponentInstance);
        }
        else if (this._hoisted) {
            (0, Utilities_1.unhoistMethods)(this, this._hoisted);
        }
    };
    return BaseDecorator;
}(React.Component));
exports.BaseDecorator = BaseDecorator;
//# sourceMappingURL=BaseDecorator.js.map